import angular from "angular";
import moment from "moment/moment";
import "core-js";

import './app-module';
import './app-theme';
import './app-constants';
import './app-routes';
import './app-controller.js';

angular
    .module('sentinel.gateway.web')
    .run(runBlock);

runBlock.$inject = ['$rootScope', '$state', '$stateParams', '$transitions', '$trace', '$location', 'SentinelUiSession', 'localStorageService', 'FeedbackService', 'AiManagedTooltip', 'ClientVersionService'];

function runBlock($rootScope, $state, $stateParams, $transitions, $trace, $location, SentinelUiSession, localStorageService, FeedbackService, AiManagedTooltip, ClientVersionService) {

    $rootScope.$state = $state;
    $rootScope.$stateParams = $stateParams;
    $rootScope.AiManagedTooltip = AiManagedTooltip;

    document.title = $rootScope.isOrs ? 'ORS' : 'OAInsight';

    var locale = window.navigator.userLanguage || window.navigator.language;
    moment.locale(locale);

    $(document).click(function (e) {
        if (e.target.id === 'closeButton' ||
            e.target.id === 'btn-toggle-menu-icon' ||
            $(e.target).hasClass('offcanvas') ||
            $(e.target).hasClass('btn-toggle') ||
            $(e.target).hasClass('offcanvas-body') ||
            $(e.target).hasClass('sidebar-nav-item') ||
            $(e.target).hasClass('sidebar-nav-member')) {
            return;
        }
        // if clicking anywhere else, close the dropdown
        if ($('#offcanvas').hasClass('show')) {
            $('#closeButton').click();
        }
    });

    // uncomment to enable transition tracing
    // $trace.enable("TRANSITION");

    // A newer build is picked up by turning the next navigation into a full page load: the user
    // is leaving the page anyway, so nothing in progress is lost. The login page has nothing to
    // lose, so it reloads as soon as a newer build is seen.
    $transitions.onStart({}, function (transition) {
        if (!ClientVersionService.isStale()) {
            ClientVersionService.check();
            return;
        }
        const url = $state.href(transition.to(), transition.params(), {absolute: true});
        if (ClientVersionService.reloadTo(url)) {
            return false;
        }
    }, {priority: 100});

    ClientVersionService.start(function () {
        if ($state.current.name === 'login') {
            ClientVersionService.reloadTo();
        }
    });

    $transitions.onStart({}, async function (transition) {
        FeedbackService.clear();
        const toState = transition.to();

        let sessionAvailable = SentinelUiSession.isValid();
        if (!sessionAvailable) {
            sessionAvailable = await SentinelUiSession.ensureSession();
        }

        if (sessionAvailable && SentinelUiSession.isExpired() && toState.name !== 'logins.password') {
            event.preventDefault();
            $rootScope.loading = false;
            $state.go('logins.password');
            return;
        }

        if (sessionAvailable && !SentinelUiSession.isEulaAgreement() && !SentinelUiSession.isExpired() && toState.name !== 'logins.termofservice') {
            event.preventDefault();
            $rootScope.loading = false;
            $state.go('logins.termofservice');
            return;
        }

        if (toState.name === 'login') {
            if (sessionAvailable) {
                $location.path("/home");
            }
            return;
        }

        if (toState.data.authorizationRequired && !sessionAvailable) {
            event.preventDefault();
            $state.go('login');
            return;
        }

        var reloadState = localStorageService.get('reloadState');
        var reloadParams = localStorageService.get('reloadParams');

        if (SentinelUiSession.isReloaded && reloadState) {
            event.preventDefault();
            SentinelUiSession.isReloaded = false;
            $state.go(reloadState, reloadParams);
        }
        SentinelUiSession.isReloaded = false;
    });
}
